import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export default class UnitButton extends React.Component {

  onEvent = () => {
    this.props.highlight(this.props.value)
  }

  render() {
    const { selected } = this.props;
      return (
        <div onMouseOver={this.onEvent}
          className={cx('button',{ selected })}
        >
          <span>{this.props.label}</span>
        </div>
      );
  }
}

UnitButton.propTypes = {
  // a Button must have a label to render
  // the menu in which the Button is rendered will correspond to
  // the part of the image location string this label will affect
  label: PropTypes.number,
  // sometimes the label will not exactly match the value we want
  // to pass up to the MainContainer. For this reason, we pass that information
  // as the value for the image location apart from the label
  //value: PropTypes.string,
  //value: PropTypes.number,
  // when a Button is clicked it will pass its label up to the
  // MainContainer where the information will change the state
  // (which will affect the image being shown)
  highlight: PropTypes.func,
  selected: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/UnitButton.js